// In-memory urlId → workspaceId map, populated during auth bootstrap (loadUserData) from
// the workspace docs it already fetches. Lets workspaceSaga skip a redundant
// getDoc(workspaceUrlIds/{urlId}) on the cold-load critical path.
const urlIdToWorkspaceId = new Map<string, string>()

export function cacheWorkspaceUrlIds(entries: Array<{ urlId: string; workspaceId: string }>): void {
    for (const { urlId, workspaceId } of entries) {
        if (urlId && workspaceId) urlIdToWorkspaceId.set(urlId, workspaceId)
    }
}

export function getCachedWorkspaceId(urlId: string): string | undefined {
    return urlIdToWorkspaceId.get(urlId)
}
